
import chartOpt from './chartOptions';
import { mapState } from 'vuex';
export default {
  data () {
    return {
      pieHeight: '',
      actionInterval: '',
      communityInterval: '',
      cId: '',
      userCount: {},
      newUser: {},
      openNum: {},
      realOpen: {},
      repair: {},
      termin: {},
      activeUser: {},
      userSort: { isScroll: false, interval: {}, list: [] },
      overViewList: [],
      baseDataKey: {
        users: { title: '认证总数', unit: '人' },
        owners: { title: '业主', unit: '人' },
        families: { title: '家属', unit: '人' },
        tenants: { title: '租户', unit: '人' },
        properties: { title: '物业公司', unit: '家' },
        communities: { title: '小区', unit: '个' },
        buildings: { title: '楼栋数', unit: '栋' },
        units: { title: '单元数', unit: '个' },
        positions: { title: '位置数', unit: '个' },
        rooms: { title: '房间数', unit: '间' },
        devices: { title: '设备数', unit: '台' }
      }
    };
  },
  computed: {
    ...mapState(['dateDetail', 'forecast', 'nowWeather', 'time'])
  },
  mounted () {
    this.routeName = this.$route.name;
    let communityData = this.$route.query;
    if (communityData && communityData.id && this.routeName === 'communityVis') {
      this.pieHeight = '30.5vh';
      this.cId = communityData.id;
      let str = communityData.name;
      const specialChar = '/';
      let index = str.indexOf(specialChar);
      this.communityName = str.substring(index + 1);

      this.communityFun();
      this.publicFun();
    } else {
      this.pieHeight = '32.6vh';
      this.reqesetAll();// 保证两列轮播同时进行
      this.backDataInterval = setInterval(() => { this.reqesetAll(); }, this.intervalTime());
      this.publicFun();
    }
  },
  methods: {
    /* 社区页面的方法 循环调用 */
    communityFun () {
      let actionArr = ['getVerifyStatus', 'getBuildData'];
      actionArr.forEach((item) => { this[item](); });

      this.communityInterval = setInterval(() => {
        actionArr.forEach((item) => { this[item](); });
      }, this.intervalTime());
    },
    /* 两页面公用的方法 循环调用 */
    publicFun () {
      let chartArr = ['userCountChart', 'tenmentChart', 'openNumChart', 'realOpenChart',
        'repairChart', 'getAppData', 'getBaseData'];
      chartArr.forEach((item) => { // 循环调用方法
        if (item === 'getAppData') {
          this[item](true);
        } else {
          this[item]();
        }
      });

      let actionArr = ['getUserCount', 'getNewUser', 'getOpenNum', 'getRealOpen',
        'repairData', 'getAppData', 'getBaseData'];
      this.actionInterval = setInterval(() => { // 设置定时获取数据
        actionArr.forEach((item) => {
          this[item]();
        });
      }, this.intervalTime());
    },
    /* 每个月用户的总数走势图 */
    async userCountChart () {
      this.userCount = this.Highcharts.chart('userCount', chartOpt.lineOptions);
      this.getUserCount();
    },
    /* 每天住户新增的走势图 */
    async tenmentChart () {
      this.newUser = this.Highcharts.chart('tenment', chartOpt.columnOptions);
      this.getNewUser();
    },
    /* 每天不同方式开门次数的叠加图 */
    async openNumChart () {
      this.openNum = this.Highcharts.chart('openNum', chartOpt.stackColOptions);
      this.getOpenNum();
    },
    /* 24内不同开门方式开门次数走势图 */
    async realOpenChart () {
      this.realOpen = this.Highcharts.chart('realOpen', chartOpt.realOpenOptions);
      this.getRealOpen();
    },
    /* 饼状图报事、保修回复状态的统计 */
    repairChart () {
      this.repair = this.Highcharts.chart('repair', chartOpt.repairOptions);
      this.repairData();
    },
    /* 饼状图不同系统终端用户比例统计、近7天活跃用户占总数比例 */
    getAppData (firstCall) {
      this._get({
        url: '/statistics/distribution_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        let activeArr = [];
        let terminalArr = [];
        let activeNoData, terminalNoData;
        if (data) {
          let active = data.active_user;
          let terminal = data.terminal;
          if (active && Object.keys(active).length) {
            let arr = [];
            let keyObj = { active: '活跃', not_active: '不活跃' };
            for (let key in active) {
              arr.push(active[key]);
              activeArr.push({ name: keyObj[key], y: active[key] });
            }
            if (arr.every(ele => ele === 0)) {
              activeArr.push({ name: '暂无数据', y: 1 });
              activeNoData = true;
            }
          }

          if (terminal && Object.keys(terminal).length) {
            let terminalVal = [];
            for (let item in terminal) {
              terminalVal.push(terminal[item]);
              terminalArr.push({ name: item, y: terminal[item] });
            }
            if (terminalVal.every(ele => ele === 0)) {
              terminalArr.push({ name: '暂无数据', y: 1 });
              terminalNoData = true;
            }
          }
        }

        if (firstCall) {
          this.activeUser = this.Highcharts.chart('active-user', this.changePieOption('activeUser', activeNoData));
          this.termin = this.Highcharts.chart('termin', this.changePieOption('termin', terminalNoData));
        }
        this.activeUser.series[0].setData(activeArr);
        this.termin.series[0].setData(terminalArr);
      });
    },

    /* 获取用户总数 */
    getUserCount () {
      return new Promise((resolve, reject) => {
        this._get({
          url: '/statistics/user_statistics',
          params: {community_id: this.cId},
          config: { timeout: 20000 }
        }).then(({data}) => {
          let date = [];
          let value = [];
          data && data.forEach((ele) => {
            date.push(`${ele.month}月`);
            value.push(ele.value);
          });
          if (this.cId) {
            this.userCount.series[0].name = '住户数';
          } else {
            this.userCount.series[0].name = '注册用户数';
          }
          this.userCount.xAxis[0].setCategories(date);
          this.userCount.series[0].setData(value);
        });
      });
    },
    /* 获取新增用户 */
    getNewUser () {
      return new Promise((resolve, reject) => {
        this._get({
          url: '/statistics/householder_statistics',
          params: {community_id: this.cId},
          config: { timeout: 20000 }
        }).then(({data}) => {
          let date = [];
          let value = [];
          data && data.forEach((ele) => {
            date.push(ele.date);
            value.push(ele.value);
          });
          this.newUser.xAxis[0].setCategories(date);
          this.newUser.series[0].setData(value);
        });
      });
    },
    /* 获取开门次数 */
    getOpenNum () {
      return new Promise((resolve, reject) => {
        this._get({
          url: '/statistics/opendoor_statistics',
          params: {community_id: this.cId},
          config: { timeout: 20000 }
        }).then(({data}) => {
          let res = this.transformData(data);
          this.openNum.series[0].setData(res.face);
          this.openNum.series[1].setData(res.blueTooth);
          this.openNum.series[2].setData(res.remote);
          this.openNum.series[3].setData(res.password);
          this.openNum.series[4].setData(res.card);
          this.openNum.series[5].setData(res.video);
          this.openNum.series[6].setData(res.indoorVideo);
          this.openNum.series[7].setData(res.indoorNet);
          this.openNum.series[8].setData(res.phone);
          this.openNum.series[9].setData(res.visitorPwd);

          this.openNum.xAxis[0].setCategories(res.date);
        });
      });
    },
    /* 获取基础数据 */
    getBaseData () {
      this._get({
        url: '/statistics/base_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        if (data && Object.keys(data).length) {
          let arr = [];
          if (this.cId) {
            for (let item in this.baseDataKey) {
              if (item === 'properties' || item === 'communities') {
                delete this.baseDataKey[item];
              }
            }
          }
          for (let item in this.baseDataKey) {
            if (data.hasOwnProperty(item)) {
              arr.push({
                title: this.baseDataKey[item].title,
                value: data[item],
                unit: this.baseDataKey[item].unit
              });
            }
          }
          this.overViewList = arr;
        }
      });
    },
    /* 获取实时开门 */
    getRealOpen () {
      return new Promise((resolve, reject) => {
        this._get({
          url: '/statistics/today_opendoor_statistics',
          params: {community_id: this.cId},
          config: { timeout: 20000 }
        }).then(({data}) => {
          // let typeObj = {
          //   face: '人脸',
          //   shake: '蓝牙',
          //   net: '远程',
          //   pwd: '密码',
          //   ic_card: '刷卡',
          //   video: '云对讲',
          //   indoor_video: '室内对讲',
          //   indoor_net: '室内远程',
          //   ivr: '电话开门',
          //   visitor_pwd: '访客密码'
          // };
          // let part = Array.isArray(data) && data.length && data[0];
          // let typeArr = [];
          // Object.keys(part).forEach((item) => {
          //   if (item !== 'hour') {
          //     typeArr.push({
          //       name: typeObj[item],
          //       type: item,
          //       data: []
          //     });
          //   }
          // });
          // typeArr.forEach((el) => {
          //   data && data.forEach((item) => {
          //     el.data.push(item[el.type]);
          //   });
          // });
          // let date = [];
          // data && data.forEach((ele) => {
          //   date.push(ele.date || ele.hour.split(':')[0]);
          // });
          // this.realOpen.series = typeArr;

          let res = this.transformData(data);
          this.realOpen.series[0].setData(res.face);
          this.realOpen.series[1].setData(res.blueTooth);
          this.realOpen.series[2].setData(res.remote);
          this.realOpen.series[3].setData(res.password);
          this.realOpen.series[4].setData(res.card);
          this.realOpen.series[5].setData(res.video);
          this.realOpen.series[6].setData(res.indoorVideo);
          this.realOpen.series[7].setData(res.indoorNet);
          this.realOpen.series[8].setData(res.phone);
          this.realOpen.series[9].setData(res.visitorPwd);

          this.realOpen.xAxis[0].setCategories(res.date);
        });
      });
    },
    /* 转换数据 */
    transformData (res) {
      let face = [];
      let blueTooth = [];
      let remote = [];
      let password = [];
      let card = [];
      let video = [];
      let date = [];
      let indoorVideo = [];
      let indoorNet = [];
      let phone = [];
      let visitorPwd = [];

      res.forEach((ele) => {
        face.push(ele.face);
        blueTooth.push(ele.shake);
        remote.push(ele.net);
        password.push(ele.pwd);
        card.push(ele.ic_card);
        video.push(ele.video);
        indoorVideo.push(ele.indoor_video);
        indoorNet.push(ele.indoor_net);
        phone.push(ele.ivr);
        visitorPwd.push(ele.visitor_pwd);

        date.push(ele.date || ele.hour.split(':')[0]);
      });
      return { face, blueTooth, remote, password, card, video, date, indoorVideo, indoorNet, phone, visitorPwd };
    },
    /* 获取报修统计 */
    repairData () {
      this._get({
        url: '/statistics/repair_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        let statusObj = { no_answer: '待回复', answer: '已回复' };
        let arr = [];
        for (let item in data) {
          arr.push({
            name: statusObj[item],
            y: data[item],
            z: data[item]
          });
        }
        this.repair.series[0].setData(arr);
      });
    },
    /* 修改饼状图配置 */
    changePieOption (type, isNoData) {
      let pieOptions = chartOpt.pieOptions();
      if (isNoData === true) {
        pieOptions.plotOptions.pie.dataLabels.enabled = false;
        pieOptions.tooltip.enabled = false;
      } else {
        pieOptions.plotOptions.pie.dataLabels.enabled = true;
        pieOptions.tooltip.enabled = true;
      }
      if (this.$route.name === 'communityVis') {
        pieOptions.plotOptions.pie.size = '55%';
        pieOptions.plotOptions.pie.startAngle = 0;
        pieOptions.plotOptions.pie.dataLabels.distance = 12;
        if (type === 'termin') {
          pieOptions.colors = ['#B8A0FF', '#8158F7', '#9D7BFF'];
        } else {
          pieOptions.colors = ['#10A75E', '#4EF1A2'];
        }
      } else {
        pieOptions.plotOptions.pie.size = '65%';
        pieOptions.plotOptions.pie.startAngle = 50;
        pieOptions.plotOptions.pie.dataLabels.distance = 12;
        if (type === 'termin') {
          pieOptions.colors = ['#B8A0FF', '#8158F7', '#9D7BFF'];
        } else {
          pieOptions.colors = ['#F98F3B', '#FFC292'];
        }
      }
      return pieOptions;
    }
  }
};
